export default "__VITE_ASSET__D_YUza9J__"